import _ from 'lodash';
import React, { Fragment, PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import FormCheckbox from './FMPCheckbox';
import Grid from '@material-ui/core/Grid';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import SectionHeader from '../ui/FMPSectionHeader';

export const permissions = [
	{
		id: 'canMakeUpdates',
		display: 'Can make updates to the FMP system.',
		description: 'Controls read access vs write access throughout the FMP system.',
	},
	{
		id: 'canViewUsers',
		display: 'Can view the list of FMP users.',
		description: 'If the user sees the User menu item and if they can see a list of FMP users.',
	},
	{
		id: 'canUpdateUsers',
		display: 'Can update FMP users.',
		description: `Warning: ADMIN FEATURE. If the user can change a users permission. With this feature they can 
			give themselves and anyone access to all features in the FMP system.`,
	},
	{
		id: 'canRwContracts',
		display: 'Inventory Mgmt : Can view & modify Fuel Contracts.',
		description: 'Can the user see and modify the fuel contracts.',
	},
	{
		id: 'canRwInventoryAllocation',
		display: 'Inventory Mgmt : Can view & modify Inventory Allocation.',
		description: 'Can the user see and modify the inventory allocation.',
	},

	{
		id: 'canRwPlc',
		display: 'Pricing : Can view & modify the PLC.',
		description:
			'Can the user see and modify the Pearson Logistics Cost that is a key part of our formulas.',
	},
	{
		id: 'canRwRinCost',
		display: 'Pricing : Can view & modify the RIN Cost.',
		description:
			'Can the user see and modify the RIN Cost that is used in fuel formulas.',
	},
	{
		id: 'canRunCostOfGoodsReports',
		display: 'Inventory Mgmt : Can run Profit Reports.',
		description:
			'Can the user run profit reports. NOTE: This gives them access to most of our sensitive data.',
	},
	{
		id: 'canViewBillingAutomation',
		display: 'Automaton : Can run AP / AR automation and triage results.',
		description: 'Can the user see and run AP and AR ingestions and see the triage results.',
	},
	{
		id: 'canMakeUpdateStationFormulas',
		display: "Can update a station's fuel formulas",
		description: `Anyone can create a station, but only users with this permission can update a fuel formula for the station. 
		The goal here it to satisfy the auditors recommendation to control permissions on data changes in our system. 
		Users without this permission will still be able to see the formula but the drop down will be disabled.`,
	},
	{
		id: 'canRunFreightReports',
		display: 'Inventory Mgmt : Can run and export Freight Reports.',
		description:
			"Can the user run freight reports. May include freight costs we don't want external parties privy too",
	},
	{
		id: 'canViewPricingNotifications',
		display: 'Pricing Notifications: Can view',
		description:
			'Can the user view pricing notification jobs and access the notification job page.',
	},
	{
		id: 'canEditPricingNotifications',
		display: 'Pricing Notifications: Can edit',
		description: 'Can the user edit pricing notification jobs and create/update notification jobs.',
	},
];

const styles = () => {
	return {};
};

class PermissionPicker extends PureComponent {
	render() {
		const { label, value, path, onChange, disabled, error, helpText, role } = this.props;

		const hasError = !!error;
		let options = _.sortBy(permissions, 'display').map((permission) => {
			const { id, display, description } = permission;
			return { id, display, description };
		});

		const isExternalLogistics = role === 'externalLogistics';
		if (isExternalLogistics) {
			options = [_.find(options, { id: 'canMakeUpdates' })];
		}

		return (
			<Fragment>
				<SectionHeader label={label} />
				<FormControl fullWidth={true} error={hasError} disabled={disabled}>
					<Grid container spacing={2}>
						{options.map(({ id, display, description }) => {
							const childPath = `${path}.${id}`;
							return (
								<Grid item xs={12} sm={12} key={childPath}>
									<FormCheckbox
										path={childPath}
										label={display}
										value={id}
										checked={!!value[id]}
										onChange={onChange}
									/>
									{description && (
										<div
											style={{
												padding: '10px',
												border: '1px solid #ddd',
												marginLeft: '5px',
												fontSize: '14px',
											}}
										>
											{description}
										</div>
									)}
								</Grid>
							);
						})}
					</Grid>
					{hasError && <FormHelperText>{error}</FormHelperText>}
					{helpText && !hasError && <FormHelperText>{helpText}</FormHelperText>}
				</FormControl>
			</Fragment>
		);
	}
}

PermissionPicker.propTypes = {
	label: PropTypes.string,
	value: PropTypes.object.isRequired,
	path: PropTypes.string.isRequired,
	onChange: PropTypes.func.isRequired,
	error: PropTypes.string,
	disabled: PropTypes.bool,

	classes: PropTypes.object,
	md: PropTypes.number,
	helpText: PropTypes.string,
	role: PropTypes.string,
};

PermissionPicker.defaultProps = {
	md: 12,
	label: 'FMP Permissions',
};

export default _.flow([withStyles(styles)])(PermissionPicker);
